"use client";

import { usePathname } from "/navigation";
import { useLocale, useTranslations } from "next-intl";
import React from "react";
import color from "../../styles/_helpers/branding.module.scss";
import { ApplicationType, ButtonSizeType, SummaryPage, SummaryPageOld } from "@into-discovery/browsewebshared";
import { ISummaryProps } from "/models/summary/ISummaryProps";

type Props = {
  pageProps: ISummaryProps;
};

export default function SummaryProvider({ pageProps }: Props) {
  const locale = useLocale();
  const pagePath = usePathname();
  const translate = useTranslations(`Redirect`);
  const brandURL = `/${locale}`;
  const applyURL = `${process.env.NEXT_PUBLIC_INTO_STUDY_APPLY_URL}/application/course`;
  const catalogServiceConfig = {
    urlV1: `${process.env.NEXT_PUBLIC_CATALOG_SERVICE_URL}/v1`,
    urlV2: `${process.env.NEXT_PUBLIC_CATALOG_SERVICE_URL}/v2`,
    locale: ``,
    includePrerelease: process.env.NEXT_PUBLIC_INCLUDE_PRERELEASE_COURSE === `true`
  };
  const summaryPageSettings = {
    applyURL,
    brandURL,
    buttonCopyColor: color.white,
    buttonSize: ButtonSizeType.Medium,
    backgroundColor: pageProps?.invertedTheme ? pageProps?.brandPrimaryColor : pageProps?.themeColor,
    hoverBackgroundColor: pageProps?.invertedTheme ? pageProps?.brandPrimaryColor : pageProps?.themeColor,
    activeBackgroundColor: pageProps?.invertedTheme ? pageProps?.brandPrimaryColor : pageProps?.themeColor,
    b2cFlag: true,
    catalogServiceConfig,
    redirectModal: {
      title: translate(`title`),
      message: translate(`message`),
      buttonText: translate(`buttonText`)
    }
  };

  const isDEBrandEnabled = pageProps?.showDeGridsByCountry?.some(
    (x) => x === pageProps?.content?.brand?.fields?.countryCode
  );

  return (
    <>
      {isDEBrandEnabled ? (
        <SummaryPage
          summaryPageSettings={summaryPageSettings}
          summaryContent={pageProps?.content}
          summaryData={pageProps?.summaryData}
          pagePath={pagePath}
          application={ApplicationType.UniBrandedB2c}
          googleTagId={process.env.NEXT_PUBLIC_GTM_CONTAINER_ID}
          courseList={pageProps?.courses}
        />
      ) : (
        <SummaryPageOld
          summaryPageSettings={summaryPageSettings}
          summaryContent={pageProps?.content}
          summaryData={pageProps?.summaryData}
          pagePath={pagePath}
          application={ApplicationType.UniBrandedB2c}
          googleTagId={process.env.NEXT_PUBLIC_GTM_CONTAINER_ID}
          courseList={pageProps?.courses}
        />
      )}
    </>
  );
}
